import styled from 'styled-components';
import { ButtonTag } from '../../components/Button/styles';

export const Button = styled(ButtonTag)`
  width: 100%;
`;

export const ModalButtonContainer = styled.div`
  padding: 15px 20px;
  position: fixed;
  width: 100%;
  bottom: 0;

  background-color: ${({ theme }) => theme.white};
`;

export const ModalTitle = styled.h3`
  font-weight: normal;
  margin: 0;
  margin-bottom: 15px;
`;

export const ModalContainer = styled.div`
  padding: 25px 20px 105px;

  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;

    button {
      margin: 0;
    }
  }
`;

export const CloseBtn = styled.button`
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;

  padding-right: 10px;

  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  width: 50px;
  height: 50px;

  background-color: transparent;
  background-image: linear-gradient(135deg, #2DB9FE 0%, #4EDBFC 100%);
  box-shadow: 0 0 20px rgba(30, 182, 255, 0.24);
  border: none;
  border-radius: 0 0 0 100px;
  outline: none;

  svg {
    stroke: ${({ theme }) => theme.white};
  }
`;

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-x: scroll;

  margin: 0;
  padding: 60px 0 0 0;


  display: block;

  background-color: ${({ theme }) => theme.white};
  z-index: 10;
`;

export const ModalHeader = styled.header`
  position: fixed;
  z-index: 20;
  top: 0;
  left: 0;

  width: 100%;
  padding: 20px 25px;

  color: ${({ theme }) => theme.blue};
  background-color: ${({ theme }) => theme.white};

  border-bottom: 1px solid #f5f5f5;
`;
